import styled from 'styled-components';
import { md_mobile_breakpoint } from 'pubweb-smokey/dist/components/GridSystem/_vars_widths.js';

const headingStyles = {
  xxlarge: {
    fontSize: '48px',
    fontSizeMobile: '32px',
    fontWeight: '900',
  },
  xlarge: {
    fontSize: '36px',
    fontSizeMobile: '26px',
    fontWeight: '900',
  },
  large: {
    fontSize: '26px',
    fontSizeMobile: '22px',
    fontWeight: '500',
  },
  medium: {
    fontSize: '22px',
    fontSizeMobile: '18px',
    fontWeight: '600',
  },
  small: {
    fontSize: '18px',
    fontSizeMobile: '16px',
    fontWeight: '500',
  },
  xxsmall: {
    fontSize: '12px',
    fontSizeMobile: '11px',
    fontWeight: '500',
  },
};

const HeadingStyled = styled.div`
  color: ${(props) => (props.headingColor ? props.headingColor : '#414042')};
  font-family: 'acumin-pro';
  text-align: ${(props) => (props.isCentered ? 'center' : null)};
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  span {
    font-size: ${(props) => headingStyles[props.headingSize].fontSize};
    font-weight: ${(props) => headingStyles[props.headingSize].fontWeight};
    letter-spacing: ${(props) =>
      headingStyles[props.headingSize] === 'xxsmall' && '2.5px'};
  }
  text-transform: ${(props) =>
    headingStyles[props.headingSize] === 'xxsmall' ? 'uppercase' : 'none'};
  max-width: ${(props) => (props.largeCard ? 'none' : '92%')};

  @media screen and (max-width: ${md_mobile_breakpoint}px) {
    h1,
    h2,
    h3,
    h4,
    h5,
    h6,
    span {
      font-size: ${(props) => headingStyles[props.headingSize].fontSizeMobile};
    }
  }
`;

export default HeadingStyled;
